import { TAB_KEY } from '../../../content-editable/constants/keys';

const preventTabHandling = (e) => {
  if (e.key !== TAB_KEY) return;

  e.preventDefault();
};

export default preventTabHandling;
